import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { postRequest } from "../../../helpers/api.helper";
import { toast } from "react-toastify";

type ShortListModalProps = {
  closeShortlistModal: () => void;
  profile: any;
  setShortlistedProfiles: (profiles: any) => void;
};

const ShortListModal = ({
  closeShortlistModal,
  profile,
  setShortlistedProfiles,
}: ShortListModalProps) => {
  const [shortlistNote, setShortlistNote] = useState("");
  const [shortlistLoading, setShortlistLoading] = useState(false);

  // Submit shortlist
  const handleShortlistSubmit = async () => {
    setShortlistLoading(true);
    try {
      const shortlistData = {
        profileId: profile?._id,
        note: shortlistNote,
      };
      const response = await postRequest(
        `/bureau/profiles/shortlist/toggle`,
        shortlistData,
      );
      if (response.success) {
        toast.success("Profile shortlisted successfully");
        setShortlistedProfiles((prev: any) => new Set([...prev, profile?._id]));
        closeShortlistModal();
      } else {
        toast.error("Failed to shortlist profile. Please try again.");
      }
    } catch (error) {
      console.error("Error shortlisting profile:", error);
      toast.error("Error shortlisting profile. Please try again.");
    } finally {
      setShortlistLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-pink-600">Shortlist Profile</h2>
          <button
            onClick={closeShortlistModal}
            className="text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
        </div>

        <div className="mb-4 p-3 bg-pink-50 rounded">
          <p className="text-sm text-gray-600">Shortlisting Profile:</p>
          <p className="font-semibold">{profile.fullName}</p>
          <p className="text-sm text-gray-600">
            Marital ID: {profile.martialId}
          </p>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Add a Note (Optional)
          </label>
          <textarea
            value={shortlistNote}
            onChange={(e) => setShortlistNote(e.target.value)}
            placeholder="Add a personal note about this profile..."
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
            rows={3}
          />
        </div>

        <div className="flex space-x-4">
          <button
            onClick={closeShortlistModal}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            disabled={shortlistLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleShortlistSubmit}
            disabled={shortlistLoading}
            className="flex-1 py-2 px-4 bg-pink-600 text-white rounded-md hover:bg-pink-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {shortlistLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Adding...
              </>
            ) : (
              "Add to Shortlist"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShortListModal;
